<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <vue-element-loading :active="appLoading2" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-card color="#1fb07c" flat>
      <v-layout wrap justify-center>
        <v-flex xs12 md12 pt-6 text-center>
          <!-- <p id="invest_head">Current Investment Opportunities</p> -->
          <p id="invest_head">Invested Projects</p>
        </v-flex>
      </v-layout>
      <!-- <v-app-bar color="#1fb07c" dark dense flat>
        <v-layout wrap justify-center text-center>
          <v-flex xs6 sm6 md2>
            <v-menu transition="slide-y-transition" offset-y>
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on" class="select_Menu">
                  <span v-if="categoryFilter">{{categoryFilter}}</span>
                  <span v-else>Category</span>
                  <v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list v-model="categoryid">
                <v-list-item
                  v-for="(item,i) in categories"
                  v-bind:value="item._id"
                  :key="i"
                  @click="getSearch(item,'category')"
                >
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex xs6 sm6 md2>
            <v-menu transition="slide-y-transition" offset-y>
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on" class="select_Menu">
                  <span v-if="locationFilter">{{locationFilter}}</span>
                  <span v-else>Location</span>
                  <v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list v-model="country">
                <v-list-item
                  v-for="(item, i) in locations"
                  :key="i"
                  @click="getSearch(item,'location')"
                >
                  <v-list-item-title>{{ item.country }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex xs6 sm6 md2>
            <v-menu transition="slide-y-transition" offset-y>
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on" class="select_Menu">
                  <span v-if="investmentTypeFilter">{{investmentTypeFilter}}</span>
                  <span v-else>Investment Type</span>
                  <v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list v-model="investmentType">
                <v-list-item
                  v-for="(item, i) in investmentTypes"
                  :key="i"
                  @click="getSearch(item,'investmentType')"
                >
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-app-bar>-->
    </v-card>
    <!-- /////////////////////////////////////////////////////////////// -->
    <!-- <v-layout px-4 wrap justify-center pt-5>
      <v-flex xs12 md6>
        <v-text-field
          v-model="searchKey"
          solo
          type="search"
          label="Search by company name"
          color="#26af82"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-flex>
    </v-layout>-->
    <v-layout
      v-if="hasProject"
      class="invest_opts"
      style="min-height:80vh"
      px-4
      wrap
      justify-center
      pt-8
      pb-5
    >
      <v-flex v-for="(item,i) in projectData" :key="i" xs12 md10 pb-2>
        <router-link :to="'/Project/'+item._id">
          <v-card>
            <v-layout wrap>
              <v-flex xs12 md2>
                <v-img
                  class="white--text align-center"
                  height="100%"
                  style="border-radius: 3px;"
                  :src="baseURL+'/u/'+item.logo"
                >
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-flex>
              <!-- /////////////////// -->
              <v-flex xs12 md10>
                <v-layout wrap>
                  <v-flex xs12 md9 px-3 pt-3 text-justify>
                    <p style="font-size:14px;font-weight:500">
                      {{item.name}}
                      <br />
                      <span
                        style="font-size:12px;font-weight:300;color:grey;"
                        v-if="item.shortDescription.length>250"
                        v-html="item.shortDescription.substring(0,250)+'...'"
                      ></span>
                      <span
                        style="font-size:12px;font-weight:300;color:grey;"
                        v-else
                        v-html="item.shortDescription"
                      ></span>
                    </p>
                    <p
                      style="font-size:14px;font-weight:400px"
                      v-if="item.description.length>350"
                      v-html="item.description.substring(0,350)+'...'"
                    ></p>
                    <p style="font-size:14px;font-weight:400px" v-else v-html="item.description"></p>
                  </v-flex>
                  <v-flex v-if="!item.mypledge" xs12 md3 px-3 pt-3 text-justify>
                    <v-layout wrap>
                      <v-flex>
                        <v-layout wrap>
                          <v-flex px-2 text-left xs6 sm6 md6>
                            <span style="font-size:12px;font-weight:400;">Raised</span>
                          </v-flex>
                          <v-flex px-2 text-right xs6 sm6 md6>
                            <span
                              style="font-size:12px;font-weight:800;color:#26af82;"
                            >{{item.raised}}%</span>
                          </v-flex>
                        </v-layout>
                        <v-layout wrap>
                          <v-flex pb-2 px-2 xs12 sm12 md12>
                            <v-progress-linear :value="item.raised" color="#26af82" rounded></v-progress-linear>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap text-center>
                      <v-flex xs12 sm12 md12>
                        <span
                          style="font-size:12px;font-weight:400;text-align:center"
                        >TOTAL INVESTED</span>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <span
                          style="font-size:20px;font-weight:800;color:#26af82;"
                        >$ {{formatPrice(item.currentReservation)}}</span>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <span
                          style="font-size:15px;font-weight:600"
                        >of $ {{formatPrice(item.fundingGoal)}}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <!-- ////////////////////////////////////////////////////////////// -->

                  <v-flex v-else xs12 md3 px-3 pt-3 text-justify>
                    <v-layout wrap>
                      <v-flex text-center>
                        <span
                          style="font-size:14px;font-weight:400;color:#26af82"
                        >Securities Holding</span>
                      </v-flex>
                    </v-layout>
                    <v-card outlined tile>
                      <v-layout id="investments" wrap>
                        <v-flex pa-2 v-for="(item,i) in item.mypledge.payment" :key="i">
                          <v-layout px-2 wrap>
                            <v-flex xs12 sm12 md12>
                              <span style="font-size:13px;font-weight:500;">Security {{i+1}}</span>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <span style="font-size:12px;font-weight:400;">Invested</span>
                            </v-flex>
                            <v-flex xs6 sm6 md6 text-right>
                              <span style="font-size:12px;font-weight:400;">${{item.investment}}</span>
                            </v-flex>
                          </v-layout>
                          <v-layout px-2 wrap>
                            <v-flex xs6 sm6 md8>
                              <span style="font-size:12px;font-weight:400;">Value at Maturity</span>
                            </v-flex>
                            <v-flex xs6 sm6 md4 text-right>
                              <span
                                style="font-size:12px;font-weight:400;"
                              >${{item.valueAtMaturity}}</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 md9 px-2>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex xs12 md3 px-4>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 md9 text-center>
                    <v-layout wrap pl-3 pb-3 pt-2 justify-left>
                      <v-flex>
                        <v-layout v-if="!item.mypledge" wrap pa-0>
                          <v-flex xs12 sm4 md4>
                            <v-layout wrap text-left>
                              <v-flex xs6 sm12 md12>
                                <span style="font-size:12px;color:#444444;">CURRENT RESERVATION</span>
                              </v-flex>
                              <v-flex xs6 sm12 md12>
                                <span
                                  style="font-size:14px;font-weight:500;color:#1A1A1A"
                                >${{formatPrice(item.currentReservation)}}</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm4 md4>
                            <v-layout wrap text-left>
                              <v-flex xs6 sm12 md12>
                                <span style="font-size:12px;color:#444444;">TERM LENGTH (Years)</span>
                              </v-flex>
                              <v-flex xs6 sm12 md12>
                                <span
                                  style="font-size:14px;font-weight:500;color:#1A1A1A"
                                >{{item.durationOfInvestment}}</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm4 md4>
                            <v-layout wrap text-left>
                              <v-flex xs6 sm12 md12>
                                <span style="font-size:12px;color:#444444;">FUNDING GOAL</span>
                              </v-flex>
                              <v-flex xs6 sm12 md12>
                                <span
                                  style="font-size:14px;font-weight:500;color:#1A1A1A"
                                >${{formatPrice(item.fundingGoal)}}</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <!-- ///////////////////////////////////// -->

                        <v-layout v-else wrap pa-0>
                          <v-flex xs12 sm4 md4>
                            <v-layout wrap text-left>
                              <v-flex xs6 sm12 md12>
                                <span style="font-size:12px;color:#444444;">STATUS</span>
                              </v-flex>
                              <v-flex xs6 sm12 md12>
                                <span
                                  style="font-size:14px;font-weight:500;color:#1A1A1A"
                                >{{item.mypledge.pledgestatus}}</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm4 md4>
                            <v-layout wrap text-left>
                              <v-flex xs6 sm12 md12>
                                <span style="font-size:12px;color:#444444;">TOTAL INVESTMENT</span>
                              </v-flex>
                              <v-flex xs6 sm12 md12>
                                <span
                                  style="font-size:14px;font-weight:500;color:#1A1A1A"
                                >${{formatPrice(item.mypledge.totalInvestment)}}</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm4 md4>
                            <v-layout wrap text-left>
                              <v-flex xs6 sm12 md12>
                                <span style="font-size:12px;color:#444444;">TOTAL VALUE AT MATURITY</span>
                              </v-flex>
                              <v-flex xs6 sm12 md12>
                                <span
                                  style="font-size:14px;font-weight:500;color:#1A1A1A"
                                >${{formatPrice(item.mypledge.totalValueAtMaturity)}}</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md3 px-4>
                    <v-layout pt-2 wrap justify-center>
                      <v-flex xs4 sm4 md4 align-center text-right pt-1>
                        <v-avatar size="38">
                          <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John" />
                        </v-avatar>
                      </v-flex>
                      <v-flex xs8 sm8 md8 text-center align-center>
                        <v-layout wrap>
                          <v-flex xs12 sm12 md12 text-uppercase>
                            <span style="font-size:12px;font-weight:300;color:#949494">Created By</span>
                          </v-flex>
                          <v-flex xs12 sm12 md12 text-uppercase>
                            <span
                              style="font-size:12px;font-weight:500;color:#171717"
                            >{{item.addedby.username}}</span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- ///////////////////// -->
            </v-layout>
          </v-card>
        </router-link>
      </v-flex>
    </v-layout>

    <v-layout v-else class="invest_opts" px-4 wrap justify-center pt-2 pb-5>
      <v-flex xs12 md10 pb-2>
        <v-card>
          <v-layout wrap>
            <v-flex pa-12 text-center>
              <span style="font-size:20px;font-weight:500">No Projects</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      ServerError: false,
      projectData: [],
      searchKey: "",
      appLoading: false,
      appLoading2: false,
      raised: null,
      country: "",
      categoryid: "",
      categories: [],
      investmentType: null,
      investmentTypes: [
        { name: "All Types", _id: "All" },
        { name: "Invested", _id: "Invested" },
        { name: "Not Invested", _id: "Not Invested" }
      ],
      categoryFilter: null,
      locations: [],
      locationFilter: null,
      investmentTypeFilter: null,
      hasProject: false
    };
  },
  // watch: {
  //   searchKey: function() {
  //     this.getSearch();
  //   }
  // },
  beforeMount() {
    // this.getData();
    this.getSearch(this.investmentTypes[1], "investmentType");
    // this.getCategory();
    // this.getLocation();
  },
  methods: {
    formatPrice(value) {
      let val = value / 1;
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getCategory() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/project/category/getlist"
      })
        .then(response => {
          this.categories = response.data.data;
          var res = [{ name: "All Categories", _id: "All Categories" }];
          this.categories = res.concat(this.categories);
          this.appLoading = false;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    getLocation() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/country/getlist"
      })
        .then(response => {
          this.locations = response.data.data;
          var res = [{ country: "All Locations", _id: "All" }];
          this.locations = res.concat(this.locations);
          this.appLoading = false;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    getSearch(item, type) {
      if (type == "category") {
        this.categoryid = item._id;
        this.categoryid = encodeURIComponent(this.categoryid);
        this.categoryFilter = item.name;
      }
      if (type == "location") {
        this.country = item.country;
        this.country = encodeURIComponent(this.country);
        this.locationFilter = item.country;
      }
      if (type == "investmentType") {
        this.investmentType = item._id;
        this.investmentType = encodeURIComponent(this.investmentType);
        this.investmentTypeFilter = item.name;
      }
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/project/search",
        params: {
          categoryid: this.categoryid,
          country: this.country,
          key: this.searchKey,
          type: this.investmentType
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.projectData = response.data.data;
            if (this.projectData.length > 0) this.hasProject = true;
            else this.hasProject = false;
            for (var i = 0; i < this.projectData.length; i++) {
              this.projectData[i].raised = (
                (this.projectData[i].currentReservation /
                  this.projectData[i].fundingGoal) *
                100
              ).toFixed(2);
            }
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    getData() {
      this.appLoading2 = true;
      axios({
        method: "GET",
        url: "/project/getlist/1/10",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading2 = false;
          if (response.data.status === true) {
            this.projectData = response.data.data;
            if (this.projectData.length > 0) this.hasProject = true;
            else this.hasProject = false;
            for (var i = 0; i < this.projectData.length; i++) {
              this.projectData[i].raised = (
                (this.projectData[i].currentReservation /
                  this.projectData[i].fundingGoal) *
                100
              ).toFixed(2);
            }
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  }
};
</script>

<style scoped>
#invest_head {
  font-family: proxima_Bold;
  font-size: 20px !important;
  /* font-weight: 500 !important; */
  color: #fff !important;
}
.invest_opts {
  min-height: 50vh;
}
.select_Menu {
  font-family: opensans_Regular;
  text-transform: capitalize;
}
#investments {
  max-height: 150px;
  overflow-y: auto;
}
/* width */
::-webkit-scrollbar {
  width: 5px !important;
  height: 10px !important;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px grey !important;
  border-radius: 5px !important;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #919191 !important;
  border-radius: 5px !important;
}
</style>